// extracted by mini-css-extract-plugin
module.exports = {"btn-resend":"R2szmFNn-UUV5dv5JG3dx","btn-invite":"_2SIRCLYTEvRkePAaj9d-ct"};